import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import ManuelAddress from './ManuellAdressForm'
import VSelect from 'Components/Select/VSelect'
import { setSelectedMember, setRecipient } from 'store/actions/customerAccountingActions'
import { Typography, Paper } from '@material-ui/core'


const RecipientForm = ({ appType, selectMembers, selectedRecipient, recipient, config: { selectedMember, accountingRecipientType, recipientType } }) => {
    const handleSelectedMember = (data) => {
        const _recipient = selectMembers[appType][accountingRecipientType].filter(member=>member.id===data.value)
        const { id, memberId, profile: {name, street, postCode, city} } = _recipient[0]
        const recipient = { id, name, street, postCode, city, memberId }
        setRecipient(recipient)
        return setSelectedMember(data)
    }
 
  return (
    <Paper style={{backgroundColor: 'white', padding: '0.5rem'}}>
        {recipientType==='select' && <Typography variant='caption' children='Emfpänger wählen' />}
        {recipientType==='select'
            ? <VSelect 
                //style={{marginTop: '1rem'}}
                fullWidth
                label='Empfänger'
                propKeys={{value: 'id', label: 'userName'}}
                selectedValue={selectedMember}
                callback={handleSelectedMember}
                data={selectMembers[appType][accountingRecipientType] || []}
            />
            : <ManuelAddress recipient={recipient} />
        }
    </Paper>
  )
}

export default compose(
    firestoreConnect(() => {
    return [  
     { collection: 'members', storeAs: '_members' },
    // { collection: 'tasks', where: [['type', '==', 'nachbarschaftshilfe']], storeAs: 'accountingTasks' }
 
    ]
}), // or { collection: 'todos' }
connect((state) => {
    
    return ({
        appType: state.user.settings.activeApp,
        config: state.customerAccounting.config,
        selectedRecipient: state.customerAccounting.config.selectedMember && state.firestore.data._members[state.customerAccounting.config.selectedMember.value],
        selectMembers : {
            nachbarschaftshilfe: {
                requester: state.firestore.ordered._members && state.firestore.ordered._members.filter(member=>member.roles.requester),
                provider: state.firestore.ordered._members && state.firestore.ordered._members.filter(member=>member.roles.provider)
            },
            pflegekasse : {
                requester: state.firestore.ordered._members && state.firestore.ordered._members.filter(member=>member.pflegekasse).filter(member=>member.pflegeRoles.requester),
                provider: state.firestore.ordered._members && state.firestore.ordered._members.filter(member=>member.pflegekasse).filter(member=>member.pflegeRoles.provider)
            }
        }
    //config: state.customerAccounting.config,
   })
}),
 )(RecipientForm)


